export const getImageAlt = (image: any): string => {
  if (!image) return "";

  if (typeof image === "string") {
    return "";
  }

  if (image.desktop?.props?.alt) {
    return image.desktop.props.alt;
  }
  if (image.props?.alt) {
    return image.props.alt;
  }
  if (typeof image.alt === "string") {
    return image.alt;
  }
  return "";
};
